import * as styles from './QuoteHero.module.scss'
import Heading from '../Heading/Heading'
import Text from '../Text/Text'

const QuoteHero = ({ title, quote, author }) => (
  <div className={styles.pageTitleContainer}>
    <div className={styles.clubTitle}>
      <Heading
        type="h1"
        headingSize="display"
        className={styles.quoteHeroTitle}
        data-testid="clue-page-title-test">
        {title}
      </Heading>
      <p className={styles.quoteHeroQuote}>{quote}</p>
      <Text className={styles.quotePerson}>- {author}</Text>
    </div>
  </div>
)

export default QuoteHero
